import { useTranslation } from 'react-i18next';

export default function HeaderOfPage({ name }: any) {
    const { t } = useTranslation();

    return (
        <div
            style={{ backgroundImage: 'url(/walls.jpg)' }}
            className="relative w-full h-[88px] mb-5 rounded-xl overflow-hidden shadow-sm bg-cover bg-center"
        >
            <div className="absolute inset-0 bg-gradient-to-l from-black/70 via-black/55 to-black/35" />
            <div className="relative h-full flex items-center justify-start px-5 sm:px-6">
                <h1 className="text-white text-lg sm:text-xl font-semibold tracking-wide drop-shadow-sm">
                    {t(name)}
                </h1>
            </div>
        </div>
    );
}
